import { styled } from "styled-components";

export const Marker = styled.span<{ backgroundColor: string }>`
    display: block;
    flex-shrink: 0;
    height: 12px;
    width: 12px;
    margin-right: 8px;
    background: ${({ backgroundColor }) => backgroundColor};
    border-radius: 100%;
`;
